<template>
  <div>
    <div class="card bg-white rounded">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <feather-icon
            class="mr-4"
            icon="StarIcon"
            svgClasses="text-black stroke-current w-36.96 h-36.96"
          ></feather-icon>
          <h1
            class="mb-1 text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl"
          >
            Habilidades
          </h1>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
          <span class="my-2 md:text-base">
            Informe conhecimentos específicos que desenvolveu ao longo da vida,
            como a utilização de ferramentas e metodologias.
          </span>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-w="4" vs-xs="12" vs-sm="10">
          <vs-input
            class="w-full no-icon-border mb-1"
            v-model="payload.skill"
            name="skill"
            type="text"
            placeholder="exemplo e.g. Estatística, Programação"
            label="Habilidade/Conhecimento"
            @change="onChange"
          />
        </vs-col>

        <vs-col vs-w="2" vs-xs="12" vs-sm="2">
          <vs-input
            class="w-full no-icon-border mb-1"
            v-model="payload.time"
            placeholder="0"
            min="0"
            type="number"
            label="Tempo"
          />
        </vs-col>

        <vs-col vs-w="2" vs-xs="12" vs-sm="6">
          <label class="vs-select--label">Periodo</label>
          <v-select
            class="mb-1"
            name="period"
            :options="periods"
            :reduce="period => period.value"
            v-model="payload.period"
            @input="onSelectedField"
          />
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="left"
          vs-align="center"
          vs-w="4"
          vs-xs="12"
          vs-sm="6"
        >
          <vs-button
            color="primary"
            type="border"
            class="btn-customized fix-top-margin"
            @click="saveSkill"
            >Adicionar</vs-button
          >
        </vs-col>

        <vs-col
          class="mobile-hidden"
          v-if="experiences && experiences.length > 0"
          vs-w="12"
        >
          <vs-divider position="left"
            >Habilidades em experiências profissionais</vs-divider
          >
          <vs-row
            v-for="(item, index) in experiences"
            :key="`experiencies-${index}`"
            class="mb-2"
          >
            <div class="vertical-bar" :style="{ borderColor: color }">
              <vs-col vs-w="12">
                <vs-col vs-w="12">
                  <p class="mb-0" v-if="item && item.company && item.period">
                    {{ item.company.concat(" - ", item.period) }}
                  </p>
                </vs-col>
                <vs-col vs-w="12">
                  <vs-chip
                    v-for="(skill, index) in item.skills"
                    :key="`skill-exp-${index}`"
                    class="ml-1"
                    color="#708090"
                  >
                    {{ skill }}
                  </vs-chip>
                </vs-col>
              </vs-col>
            </div>
          </vs-row>
        </vs-col>

        <vs-col v-if="skills && skills.length > 0" vs-w="12">
          <vs-divider position="left">Outras experiências</vs-divider>
          <vs-chip
            closable
            v-for="(skill, index) in skills"
            :key="`skill-${index}`"
            class="mt-1 ml-1"
            color="#708090"
            @click="onRemoveSkill(index)"
          >
            {{ `${skill.skill} ${skill.time} ${skill.period}` }}
          </vs-chip>
        </vs-col>
      </vs-row>
    </div>

    <div class="flex flex-wrap mt-2">
      <backward-button @click="handleBackward" />
      <forward-button @click="handleForward" />
    </div>

    <vs-popup title="Remover Habilidade" :active.sync="popupActive">
      <vs-row>
        <vs-col
          class="mb-8"
          vs-type="flex"
          vs-align="center"
          vs-justify="start"
          vs-w="12"
        >
          <p>Deseja Remover a habilidade?</p>
        </vs-col>

        <vs-col
          class="px-0 flex-row-reverse"
          vs-type="flex"
          vs-align="center"
          vs-justify="end"
          vs-w="12"
        >
          <vs-button
            class="mx-1"
            @click="doRemoveSkill"
            color="danger"
            type="filled"
          >
            Remover
          </vs-button>
          <vs-button
            class="mx-1"
            @click="popupActive = false"
            color="dark"
            type="flat"
          >
            Cancelar
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";

export default {
  created() {
    this.googleAnalytics();
    this.fetchSkills();

    window.scroll(0, 0);
  },
  data: () => ({
    skills: [],
    experiences: [],
    payload: {
      skill: "",
      time: "",
      period: "",
      index: 0
    },
    skill_to_remove: {},
    popupActive: false
  }),
  computed: {
    periods() {
      const values = [
        {
          value:
            this.payload.time == 1 || this.payload.time == "" ? "ano" : "anos",
          label:
            this.payload.time == 1 || this.payload.time == "" ? "Ano" : "Anos"
        },
        {
          value:
            this.payload.time == 1 || this.payload.time == "" ? "mes" : "meses",
          label:
            this.payload.time == 1 || this.payload.time == "" ? "Mês" : "Meses"
        }
      ];
      return values;
    },
    ...mapState("skill", ["experienciesSkills"]),
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    }
  },
  methods: {
    handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    },

    async handleForward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/completeStep");

      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    },

    fetchSkills() {
      this.$vs.loading({ text: "Carregando..." });

      const label = sessionStorage.getItem("label");

      this.$http
        .get(`api/v1/talent/${label}/user/talent?step=skills`)
        .then(response => {
          this.$vs.loading.close();

          const { skills, experiences } = response.data.data;
          this.skills = skills;
          this.experiences = experiences;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    saveSkill() {
      if (this.payload.skill == "")
        this.notifyEmptyField({
          text: "Para adicionar, preencha a sua habilidade ou conhecimento"
        });
      else if (this.payload.time == "")
        this.notifyEmptyField({
          text:
            "Para adicionar, preencha o tempo que você possui em relação a sua habilidade"
        });
      else if (this.payload.period == "")
        this.notifyEmptyField({
          text:
            "Para adicionar, preencha o periodo que você possui em relação a sua habilidade"
        });

      const { company_label } = this.$router.history.current.params;

      this.$vs.loading({
        text: "Salvando..."
      });

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=skills`, {
          skills: [
            {
              ...this.payload
            }
          ]
        })
        .then(async response => {
          this.$vs.loading.close();

          this.payload = {
            ...this.payload,
            id: response.data.data.skills[0].id,
            index: response.data.data.skills[0].index
          };

          this.skills.push(this.payload);

          await this.$store.dispatch("skill/store", { ...this.payload });

          this.calculateProgress({ field: "skill", value: this.skills });

          this.payload = {
            skill: "",
            time: "",
            period: "",
            index: 0
          };
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    onChange(e) {
      if (e.target.name == "skill")
        this.skill = e.target.value.length > 0 ? e.target.value : "";
      if (e.target.name == "time")
        this.time = e.target.value.length > 0 ? e.target.value : "";
    },

    onSelectedField(value) {
      this.period = value;
    },
    onRemoveSkill(index) {
      this.skill_to_remove = this.skills[index];
      this.popupActive = true;
    },

    async doRemoveSkill() {
      try {
        this.$vs.loading({
          text: "Removendo..."
        });
        const result = await this.$http.delete(
          `api/v1/talents-skills/${this.skill_to_remove.id}`
        );

        if (result.status == 200) {
          this.$vs.loading.close();
          this.popupActive = false;

          // delete from vuex
          const index = this.skills.findIndex(
            skill => skill.id === this.skill_to_remove.id
          );

          this.skills = [
            ...this.skills.slice(0, index),
            ...this.skills.slice(index + 1)
          ];

          this.$store.dispatch("skill/delete", { index });

          this.calculateProgress({ field: "skill", value: this.skills });
          this.skill_to_remove = {};
        }
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Falha ao remover a habilidade",
          text:
            error.response.data.message ||
            "Falha ao realizar o procedimento contate a nossa equipe de suporte",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },

    onRemoveExperienceSkill(index) {
      this.removeExperienceSkill({ index });
      this.calculateProgress({
        field: "skill",
        value: this.experienciesSkills
      });
    },

    notifyEmptyField({ text }) {
      this.$vs.notify({
        color: "warning",
        title: "Falha ao adicionar habilidade",
        text: text,
        position: "top-right",
        time: 3200
      });
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/skills`)
        : this.$ga.page(`${company_label}/step/skills`);
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    ...mapActions("progress", ["calculateProgress"])
  },
  components: {
    ModelSelect,
    BackwardButton,
    ForwardButton,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";
.fix-top-margin {
  margin-top: 13px !important;

  @media only screen and (max-width: 770px) {
    margin-top: 18px !important;
  }
}
</style>
